import React, {useEffect, useState} from "react";
import { hasLogo, loadLogos, rememberLogo } from '../../logos';

export const OrganizationLogo = ({ iri, editorMode, size, frameSize }) => {
    const [state, setState] = useState('...');
    const timestamp = Date.now();
    const [imageUrl, setImageUrl] = useState(`/v1/documents?uri=/logo/${iri?.replace(/.*:/, '')}.png`);

    const paste = async e => {
        if (e?.clipboardData?.files?.length & editorMode) {
            const file = e.clipboardData.files[0];
            console.log('paste', file, 'iri', iri);
            var request = new Request(
                imageUrl,
                {
                    method: 'PUT',
                    body: await file.arrayBuffer()
                });
            var response = await fetch(request);
            rememberLogo(iri);

            setImageUrl(imageUrl + "#X");
            setState('loading');
            // console.log('logo uploaded', response);
        }
    }

    const selectLogo = () => {
        setState('activated');
    }

    const logoFailed = e => {
        setState('noLogo');
    }

    const logoLoaded = () => {
        setState('logoFound');
    }

    const logoReload = () => {
        let ts = Date.now();
        setState('');
        setImageUrl(`/v1/documents?uri=/logo/${iri?.replace(/.*:/, '')}.png#${ts}`);
    }

    // The list of organisations with a logo: one without is shown as such without a request.
    const [known, setKnown] = useState(hasLogo(iri));
    useEffect(() => {
        let active = true;
        setKnown(hasLogo(iri));
        loadLogos().then(() => { if (active) setKnown(hasLogo(iri)); });
        return () => { active = false; };
    }, [iri]);
    useEffect(() => {
        if (known === false && state === '') setState('noLogo');
    }, [known, state]);

    const body = () => {
        switch (state) {
            case 'loading':
                return <span>Logo wird geladen</span>;
            case 'noLogo':
                return editorMode ? <span>Kein Logo vorhanden<br/>Klicken, um ein Logo einzufügen!</span> : '';
            case 'logoFound':
                // return editorMode ? <span>Klicken, um das Logo zu ersetzen!</span> : '';
                return '';
            case 'activated':
                return editorMode ? <span>Logo aus dem Clipboard einfügen!</span> : '';
        }
    }

    useEffect(() => {
        logoReload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[iri, editorMode])

    return <div style={{ minWidth: frameSize, minHeight: frameSize, width: frameSize, height: frameSize, backgroundColor: 'white', display: 'flex', justifyContent: 'center'}}
        onPaste={paste}
        onClick={selectLogo}>
        <img src={known === false && state !== 'loading' ? undefined : imageUrl}
             style={{ display: state === 'logoFound' ? 'block' : 'none', width: size, height: size, objectFit: 'scale-down' }}
             onError={logoFailed}
             onLoad={logoLoaded}
             onClick={logoReload}
             alt="logo"/>
        <span style={{ display: state === 'noLogo' ? 'block' : 'none', width: size, height: size }}
              onClick={logoReload}>
        </span>
        { body() }
    </div>;
}